/**
 * Validation
 *
 * A collection of re-usable functions that's used for validating fields
 *
 * @since 0.5
 * @package \app\abstract
 *
 */


/**
 * validateValue
 *
 * A function to validate the correct value type of: letters, numbers;
 *
 * @since 0.5
 *
 * @param {string} valueType string
 * @param {string} value string
 * @return {bool} valid bool
 *
 */
export function validateValue( valueType, value ) {
	const lastChar = ( value != '' )? value.substr(-1) : ''; //Get the last character typed
	let valid = true; // valid is true by default
	let restrict = null; //regex pattern is null

	// If blank then return true
	if( !lastChar ) return true;

	switch( valueType ){
		case 'letters':
			restrict = /^[0-9]*$/g;
		break;

		case 'numbers':
			restrict = /\D+/g;
		break;
	}

	// If there is a match in the restrictions then its not valid
	if( lastChar.match(restrict) ) valid = false;

	return valid;
}

/**
 * validateEmail
 *
 * A function to validate the email address value;
 *
 * @since 0.5
 *
 * @param {value} email string
 * @return {bool} valid bool
 *
 */
export function validateEmail( email ) {
	//Invalid by default
	let valid = false;
	const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// If email matches the email regex then it's valid
	if ( email.match(reg) ) valid = true;

	return valid;
}

export function validateMembershipNumber( value ) {
  let valid = false;

  // Empty values are allowed for this, immediately return valid.
  if ( value == '' ) {
    return true;
  }

  // console.log('Validating', value)
  // console.log('substring', value.substr(0, 3), 'bool', value.substr(0, 3) == '620' );

  // These two conditions describe a valid membership number
  if ( value.substr(0, 3) == '620' && value.length == 16 ) {
    valid = true;
  }

  return valid;
}